import React, { useState, useEffect, useRef } from 'react';
import Select, { createFilter } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import './mySelect.css';

const createOptions = values => {
  return values.map(value => {
    if (typeof value === 'object' && value !== null && 'value' in value && 'label' in value) {
      return value;
    }
    return { value: value, label: value };
  });
};

const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const isValidString = str => {
  return typeof str === 'string' && str.trim() !== '';
};

const formatCreateLabel = inputValue => `Ajouter "${inputValue}"`;

const MySelect = ({
  values = [],
  isCreatable = false,
  onChange,
  value,
  validationType,
  set_default = false,
  autoFocus = false,
}) => {
  const [options, setOptions] = useState(createOptions(values));
  const [selectedOption, setSelectedOption] = useState(value);
  const selectRef = useRef(null);

  useEffect(() => {
    if (autoFocus && selectRef.current) {
      selectRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: 'start',
  };

  useEffect(() => {
    const newOptions = createOptions(values);
    setOptions(newOptions);
    if (value) {
      setSelectedOption(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    if (set_default && selectedOption !== '') {
      const newSelectedOption = options[0];
      setSelectedOption(newSelectedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption);
    onChange(selectedOption);
  };

  const handleCreateOption = inputValue => {
    let isValid = false;

    if (validationType === 'email') {
      isValid = isValidEmail(inputValue);
      if (!isValid) {
        alert("Merci d'entrer une adresse email valide.");
      }
    } else if (validationType === 'str') {
      isValid = isValidString(inputValue);
      if (!isValid) {
        alert('Les données saisies sont invalides.');
      }
    }

    if (isValid) {
      const newOption = { value: inputValue, label: inputValue };
      setOptions(prevOptions => [...prevOptions, newOption]);
      setSelectedOption(newOption);
      onChange(newOption);
    }
  };

  return isCreatable ? (
    <CreatableSelect
      ref={selectRef}
      className="react-select-container"
      classNamePrefix="react-select"
      value={selectedOption}
      onChange={handleChange}
      onCreateOption={handleCreateOption}
      defaultValue={options[0]}
      options={options}
      placeholder="sélectionner ou saisir..."
      formatCreateLabel={formatCreateLabel}
      filterOption={createFilter(filterConfig)}
      isClearable
      isSearchable
    />
  ) : (
    <Select
      ref={selectRef}
      className="react-select-container"
      classNamePrefix="react-select"
      value={selectedOption}
      onChange={handleChange}
      defaultValue={options[0]}
      options={options}
      placeholder="sélectionner ou saisir..."
      filterOption={createFilter(filterConfig)}
      isClearable
      isSearchable
    />
  );
};

export default MySelect;
